// Swishr — Realistic mock household data for the frontend prototype.
// One principal and their linked household network.

export const workspace = {
  id: "ws_001",
  name: "The Vance Household",
  plan: "Family Office — Premium",
  region: "London, United Kingdom",
  createdAt: "2023-04-12",
  members: 4,
};

export const currentUser = {
  id: "u_001",
  name: "Amelia Hart",
  role: "Executive Assistant",
  email: "amelia.hart@vancehousehold.com",
  phone: "+44 7700 900100",
  timezone: "GMT (London)",
  isPlatformAdmin: false,
  avatar: "https://images.unsplash.com/photo-1590650213165-c1fef80648c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
};

export const AVATARS = {
  principal: "https://images.unsplash.com/photo-1686434538659-bb72333a1054?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  linked: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
};

export const principal = {
  id: "p_001",
  name: "Jonathan Ashworth-Vance",
  role: "Principal",
  title: "Founder & Chairman, Vance Capital",
  email: "j.vance@vancecapital.com",
  phone: "+44 7700 900112",
  location: "Kensington, London",
  avatar: AVATARS.principal,
  dob: "1971-09-03",
  tags: ["Principal", "Frequent traveller", "Allergy: penicillin"],
};

// Household & linked people
export const people = [
  principal,
  {
    id: "p_002", name: "Eleanor Vance", role: "Spouse", relation: "Current partner",
    title: "Trustee, Vance Foundation", email: "eleanor.v@vancefoundation.org",
    phone: "+44 7700 900113", location: "Kensington, London", avatar: AVATARS.linked,
    dob: "1978-02-19", tags: ["Spouse", "Foundation"],
  },
  {
    id: "p_003", name: "Miranda Reid", role: "Ex-spouse", relation: "Former partner",
    title: "Architect", email: "m.reid@reidstudio.com",
    phone: "+44 7700 900114", location: "Notting Hill, London", avatar: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    dob: "1969-11-30", tags: ["Ex-spouse", "Co-parent"],
  },
  {
    id: "p_004", name: "Sophie Vance", role: "Child", relation: "Daughter",
    title: "Hillcrest Prep — Year 8", email: "—", phone: "—",
    location: "Kensington, London", avatar: "https://images.unsplash.com/photo-1489673446964-e1f989187ddc?crop=entropy&cs=srgb&fm=jpg&q=85&w=400", dob: "2012-06-21",
    tags: ["Child", "School: Hillcrest"],
  },
  {
    id: "p_005", name: "Oliver Reid", role: "Child", relation: "Son (co-parented)",
    title: "Hillcrest Prep — Year 4", email: "—", phone: "—",
    location: "Shared custody", avatar: "https://images.unsplash.com/photo-1606386666595-d135abc1e3b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=400", dob: "2016-03-14",
    tags: ["Child", "Co-parented", "Asthma"],
  },
  {
    id: "p_006", name: "Lily Vance", role: "Child", relation: "Daughter",
    title: "Little Acorns Nursery", email: "—", phone: "—",
    location: "Kensington, London", avatar: "https://images.unsplash.com/photo-1566513857792-9a52cd97e06d?crop=entropy&cs=srgb&fm=jpg&q=85&w=400", dob: "2020-10-02",
    tags: ["Child", "Nursery"],
  },
  {
    id: "p_007", name: "Maria Gonzales", role: "Staff", relation: "Nanny",
    title: "Live-in Nanny", email: "maria.g@vancehousehold.com",
    phone: "+44 7700 900120", location: "Kensington, London", avatar: "https://images.unsplash.com/photo-1662850886700-4ec19bd30d11?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    dob: "1989-07-11", tags: ["Staff", "Childcare", "Visa: Skilled Worker"],
  },
  {
    id: "p_008", name: "David Okoye", role: "Staff", relation: "Driver",
    title: "Principal Driver", email: "david.o@vancehousehold.com",
    phone: "+44 7700 900121", location: "London", avatar: "https://images.unsplash.com/photo-1614023342667-6f060e9d1e04?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    dob: "1982-01-25", tags: ["Staff", "Driver", "DBS checked"],
  },
  {
    id: "p_009", name: "Grace Bennett", role: "Staff", relation: "Housekeeper",
    title: "Head Housekeeper", email: "grace.b@vancehousehold.com",
    phone: "+44 7700 900122", location: "Kensington, London", avatar: "https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    dob: "1975-05-08", tags: ["Staff", "Household"],
  },
];

// Relationship graph edges (from principal)
export const relationships = [
  { source: "p_001", target: "p_002", label: "Spouse", type: "family" },
  { source: "p_001", target: "p_003", label: "Ex-spouse", type: "family" },
  { source: "p_001", target: "p_004", label: "Daughter", type: "family" },
  { source: "p_003", target: "p_005", label: "Son", type: "family" },
  { source: "p_001", target: "p_005", label: "Step-son", type: "family" },
  { source: "p_001", target: "p_006", label: "Daughter", type: "family" },
  { source: "p_001", target: "p_007", label: "Nanny", type: "staff" },
  { source: "p_001", target: "p_008", label: "Driver", type: "staff" },
  { source: "p_001", target: "p_009", label: "Housekeeper", type: "staff" },
];

export const contacts = [
  { id: "c_001", name: "Hillcrest Prep School", category: "School", role: "School", phone: "+44 20 7946 0011", email: "office@hillcrestprep.sch.uk", address: "12 Academy Row, London", notes: "Term dates & pickup authorisations on file.", linkedPeople: ["p_004", "p_005"] },
  { id: "c_002", name: "Dr. Anita Patel", category: "Doctor", role: "Family GP", phone: "+44 20 7946 0022", email: "reception@kensingtonclinic.co.uk", address: "Kensington Private Clinic", notes: "Principal allergy: penicillin.", linkedPeople: ["p_001", "p_002", "p_004", "p_005", "p_006"] },
  { id: "c_003", name: "Whitman & Co Solicitors", category: "Lawyer", role: "Estate & family law", phone: "+44 20 7946 0033", email: "j.whitman@whitmanco.law", address: "8 Lincoln's Inn, London", notes: "Handles trust & custody documents.", linkedPeople: ["p_001", "p_003"] },
  { id: "c_004", name: "Bright Smile Dental", category: "Dentist", role: "Family dentist", phone: "+44 20 7946 0044", email: "care@brightsmile.co.uk", address: "Chelsea, London", notes: "6-monthly checkups.", linkedPeople: ["p_001", "p_002", "p_004", "p_005", "p_006"] },
  { id: "c_005", name: "Little Acorns Nursery", category: "School", role: "Nursery", phone: "+44 20 7946 0055", email: "hello@littleacorns.co.uk", address: "Holland Park, London", notes: "Drop-off 8:30am.", linkedPeople: ["p_006"] },
  { id: "c_006", name: "Apex Private Insurance", category: "Insurance", role: "Insurance broker", phone: "+44 20 7946 0066", email: "claims@apexprivate.com", address: "Mayfair, London", notes: "Home, motor & travel cover.", linkedPeople: ["p_001"] },
];

export const notifications = [
  { id: "n_001", title: "Motor insurance expired", detail: "Range Rover policy lapsed — renew immediately.", time: "2 days ago", read: false, severity: "critical", link: "/app/renewals" },
  { id: "n_002", title: "3 documents expiring soon", detail: "2 passports and 1 visa within 60 days.", time: "Today", read: false, severity: "warning", link: "/app/documents" },
  { id: "n_003", title: "New task assigned to you", detail: "Confirm gala seating with The Savoy.", time: "1 hour ago", read: false, severity: "info", link: "/app/tasks" },
  { id: "n_004", title: "Custody handover tomorrow", detail: "Oliver to Miranda on 12 Jul.", time: "3 hours ago", read: true, severity: "info", link: "/app/calendar" },
  { id: "n_005", title: "Voice note transcribed", detail: "3 suggested tasks ready for review.", time: "Yesterday", read: true, severity: "info", link: "/app/notes" },
];

export const documents = [
  { id: "d_001", name: "Passport — Jonathan Vance", type: "Passport", person: "p_001", expiry: "2026-08-14", status: "expiring", uploaded: "2021-08-14" },
  { id: "d_002", name: "Passport — Eleanor Vance", type: "Passport", person: "p_002", expiry: "2029-01-22", status: "valid", uploaded: "2019-01-22" },
  { id: "d_003", name: "Passport — Sophie Vance", type: "Passport", person: "p_004", expiry: "2026-07-05", status: "expiring", uploaded: "2021-07-05" },
  { id: "d_004", name: "Skilled Worker Visa — Maria G.", type: "Visa", person: "p_007", expiry: "2026-07-30", status: "expiring", uploaded: "2023-07-30" },
  { id: "d_005", name: "Home Insurance Policy", type: "Insurance", person: "ws", expiry: "2026-09-01", status: "valid", uploaded: "2025-09-01" },
  { id: "d_006", name: "Motor Insurance — Range Rover", type: "Insurance", person: "ws", expiry: "2026-06-20", status: "overdue", uploaded: "2025-06-20" },
  { id: "d_007", name: "Driving Licence — David O.", type: "Licence", person: "p_008", expiry: "2027-02-11", status: "valid", uploaded: "2022-02-11" },
  { id: "d_008", name: "Custody Agreement", type: "Legal", person: "p_005", expiry: "—", status: "valid", uploaded: "2022-11-03" },
  { id: "d_009", name: "Vehicle Registration — Bentley", type: "Vehicle", person: "ws", expiry: "2026-12-01", status: "valid", uploaded: "2025-12-01" },
];

export const renewals = [
  { id: "r_001", title: "Motor Insurance — Range Rover", category: "Insurance", due: "2026-06-20", status: "overdue", owner: "Household", amount: "£2,340/yr", linkedDoc: "d_006" },
  { id: "r_002", title: "Passport — Jonathan Vance", category: "Travel", due: "2026-08-14", status: "due-soon", owner: "Jonathan", amount: "—", linkedDoc: "d_001" },
  { id: "r_003", title: "Skilled Worker Visa — Maria", category: "Immigration", due: "2026-07-30", status: "due-soon", owner: "Maria", amount: "£719", linkedDoc: "d_004" },
  { id: "r_004", title: "Passport — Sophie", category: "Travel", due: "2026-07-05", status: "due-soon", owner: "Sophie", amount: "—", linkedDoc: "d_003" },
  { id: "r_005", title: "Home Insurance", category: "Insurance", due: "2026-09-01", status: "scheduled", owner: "Household", amount: "£4,100/yr", linkedDoc: "d_005" },
  { id: "r_006", title: "Annual Health Checkup — Jonathan", category: "Health", due: "2026-10-12", status: "scheduled", owner: "Jonathan", amount: "—" },
  { id: "r_007", title: "School Fees — Autumn Term", category: "Education", due: "2026-09-05", status: "scheduled", owner: "Sophie & Oliver", amount: "£18,600" },
];

export const events = [
  { id: "e_001", title: "Parents' Evening — Hillcrest", date: "2026-07-02", time: "16:00", person: "Sophie", category: "School", location: "Hillcrest Prep" },
  { id: "e_002", title: "Flight to Geneva (Board mtg)", date: "2026-07-04", time: "09:40", person: "Jonathan", category: "Travel", location: "LCY Terminal" },
  { id: "e_003", title: "Lily — Nursery Sports Day", date: "2026-07-08", time: "10:00", person: "Lily", category: "School", location: "Little Acorns" },
  { id: "e_004", title: "Dental checkup — whole family", date: "2026-07-11", time: "14:30", person: "Household", category: "Health", location: "Bright Smile" },
  { id: "e_005", title: "Oliver with Miranda (custody)", date: "2026-07-12", time: "All day", person: "Oliver", category: "Family", location: "Notting Hill" },
  { id: "e_006", title: "Foundation Gala", date: "2026-07-19", time: "19:00", person: "Eleanor", category: "Social", location: "The Savoy" },
  { id: "e_007", title: "Range Rover service", date: "2026-07-22", time: "08:00", person: "Household", category: "Household", location: "Mayfair Motors" },
];

export const tasks = [
  { id: "t_001", title: "Renew Range Rover motor insurance", status: "overdue", priority: "high", category: "cat_admin", assignee: "Amelia Hart", person: "Household", due: "2026-06-20", source: "manual" },
  { id: "t_002", title: "Submit Maria's visa renewal documents", status: "in-progress", priority: "high", category: "cat_admin", assignee: "Amelia Hart", person: "Maria", due: "2026-07-25", source: "renewal" },
  { id: "t_003", title: "Book Sophie's passport appointment", status: "todo", priority: "high", category: "cat_travel", assignee: "Amelia Hart", person: "Sophie", due: "2026-06-30", source: "ai" },
  { id: "t_004", title: "Confirm parents' evening attendance", status: "todo", priority: "medium", category: "cat_meeting", assignee: "Eleanor Vance", person: "Sophie", due: "2026-07-01", source: "manual" },
  { id: "t_005", title: "Arrange airport car for Geneva trip", status: "todo", priority: "medium", category: "cat_travel", assignee: "David Okoye", person: "Jonathan", due: "2026-07-03", source: "ai" },
  { id: "t_006", title: "Pay autumn term school fees", status: "todo", priority: "medium", category: "cat_admin", assignee: "Amelia Hart", person: "Sophie & Oliver", due: "2026-09-05", source: "renewal" },
  { id: "t_007", title: "Order Lily's nursery sports day kit", status: "done", priority: "low", category: "cat_personal", assignee: "Maria Gonzales", person: "Lily", due: "2026-06-25", source: "manual" },
  { id: "t_008", title: "Reschedule chef's holiday cover", status: "done", priority: "low", category: "cat_admin", assignee: "Grace Bennett", person: "Household", due: "2026-06-18", source: "voice" },
  { id: "t_009", title: "Confirm gala seating with The Savoy", status: "in-progress", priority: "medium", category: "cat_planning", assignee: "Amelia Hart", person: "Eleanor", due: "2026-07-15", source: "manual" },
];

// User-customisable task categories (colour = key from src/lib/colors.js)
export const taskCategories = [
  { id: "cat_urgent", name: "Urgent", color: "red" },
  { id: "cat_meeting", name: "Meetings", color: "sky" },
  { id: "cat_travel", name: "Travel", color: "indigo" },
  { id: "cat_personal", name: "Personal", color: "emerald" },
  { id: "cat_planning", name: "Planning", color: "violet" },
  { id: "cat_admin", name: "Admin", color: "amber" },
  { id: "cat_general", name: "General", color: "slate" },
];

export const alerts = [
  { id: "a_001", title: "Motor insurance expired", detail: "Range Rover policy lapsed on 20 Jun. Immediate renewal needed.", severity: "critical", time: "2 days ago", category: "Renewal" },
  { id: "a_002", title: "3 documents expiring within 60 days", detail: "Jonathan & Sophie passports, Maria's visa.", severity: "warning", time: "Today", category: "Document" },
  { id: "a_003", title: "Overdue task: school fees not scheduled", detail: "Autumn term fees due 5 Sep — payment not yet arranged.", severity: "warning", time: "Today", category: "Task" },
  { id: "a_004", title: "Custody handover tomorrow", detail: "Oliver to Miranda on 12 Jul — confirm pickup time.", severity: "info", time: "1 hour ago", category: "Family" },
  { id: "a_005", title: "Travel conflict detected", detail: "Geneva flight overlaps with dental checkup for Jonathan.", severity: "warning", time: "3 hours ago", category: "Calendar" },
];

export const voiceNotes = [
  { id: "v_001", title: "Morning walk note", type: "voice", duration: "0:42", date: "2026-06-28", transcript: "Remind me to book Sophie's passport appointment before end of month, and check whether the Geneva trip clashes with her parents' evening. Also ask Grace to arrange chef holiday cover.", suggestedTasks: ["Book Sophie's passport appointment", "Check Geneva vs parents' evening clash", "Arrange chef holiday cover"] },
  { id: "v_002", title: "After call with Whitman & Co", type: "voice", duration: "1:15", date: "2026-06-26", transcript: "Miranda confirmed she'll take Oliver on the 12th, all day. Need to update the custody calendar and let Maria know she's off that afternoon. Whitman to send the revised agreement next week.", suggestedTasks: ["Update custody calendar for 12 Jul", "Notify Maria of afternoon off", "Chase revised custody agreement"] },
  { id: "v_003", title: "Quick reminder", type: "voice", duration: "0:18", date: "2026-06-24", transcript: "Range Rover insurance is overdue — renew today and confirm the new premium with Apex.", suggestedTasks: ["Renew Range Rover insurance", "Confirm new premium with Apex"] },
  { id: "v_004", title: "Travel prep checklist", type: "text", duration: "—", date: "2026-06-27", transcript: "Geneva trip: confirm hotel, arrange airport transfer, pack board papers, check Jonathan's lounge access and travel insurance is active.", suggestedTasks: ["Confirm Geneva hotel", "Arrange airport transfer"] },
];

export const aiDailyBrief = {
  date: "Monday, 29 June 2026",
  greeting: "Good morning, Amelia",
  summary: "The household has 1 critical item and 5 things needing attention today. Jonathan travels to Geneva on Thursday; Sophie's passport and Maria's visa both need action before the summer.",
  highlights: [
    { icon: "alert", text: "Range Rover motor insurance is overdue — renew today.", tone: "critical" },
    { icon: "calendar", text: "Geneva flight (Thu) overlaps with a family dental checkup.", tone: "warning" },
    { icon: "doc", text: "3 documents expire within 60 days (2 passports, 1 visa).", tone: "warning" },
    { icon: "check", text: "Lily's sports day kit ordered and confirmed.", tone: "good" },
  ],
  focus: ["Renew Range Rover insurance", "Book Sophie's passport appointment", "Resolve Geneva calendar clash"],
};

// ----- Reports / chart data -----
export const reportData = {
  tasksByStatus: [
    { name: "To do", value: 4, color: "#2D74B4" },
    { name: "In progress", value: 3, color: "#D99A00" },
    { name: "Done", value: 2, color: "#28A263" },
    { name: "Overdue", value: 1, color: "#D94255" },
  ],
  householdActivity: [
    { week: "W1", tasks: 12, notes: 4, events: 6 },
    { week: "W2", tasks: 18, notes: 6, events: 8 },
    { week: "W3", tasks: 9, notes: 3, events: 5 },
    { week: "W4", tasks: 21, notes: 7, events: 9 },
  ],
  eventsByCategory: [
    { category: "School", count: 8 },
    { category: "Health", count: 5 },
    { category: "Travel", count: 6 },
    { category: "Social", count: 3 },
    { category: "Household", count: 7 },
    { category: "Family", count: 4 },
  ],
  renewalsTimeline: [
    { month: "Jun", count: 1, label: "Overdue" },
    { month: "Jul", count: 3, label: "Due soon" },
    { month: "Aug", count: 1, label: "Scheduled" },
    { month: "Sep", count: 2, label: "Scheduled" },
    { month: "Oct", count: 1, label: "Scheduled" },
    { month: "Nov", count: 0, label: "—" },
  ],
  weeklySummary: [
    { label: "Tasks completed", value: 14, change: "+12%", trend: "up" },
    { label: "Notes captured", value: 7, change: "+3", trend: "up" },
    { label: "Renewals on track", value: "6 / 7", change: "1 overdue", trend: "down" },
    { label: "Avg. response time", value: "2.4h", change: "-18%", trend: "up" },
  ],
};

// ----- Platform Admin data -----
export const adminWorkspaces = [
  { id: "ws_001", name: "The Vance Household", owner: "Amelia Hart", plan: "Premium", status: "active", users: 4, principals: 1, region: "London, UK", created: "2023-04-12" },
  { id: "ws_002", name: "Lindqvist Family Office", owner: "Erik Lindqvist", plan: "Premium", status: "active", users: 7, principals: 2, region: "Stockholm, SE", created: "2022-11-30" },
  { id: "ws_003", name: "Okonkwo Residence", owner: "Ngozi Okonkwo", plan: "Standard", status: "active", users: 3, principals: 1, region: "Lagos, NG", created: "2024-02-18" },
  { id: "ws_004", name: "Hartley Estate", owner: "Tom Hartley", plan: "Standard", status: "trial", users: 2, principals: 1, region: "New York, US", created: "2026-06-01" },
  { id: "ws_005", name: "Berg Holdings PA Team", owner: "Sofia Berg", plan: "Premium", status: "suspended", users: 5, principals: 3, region: "Geneva, CH", created: "2021-08-09" },
];

export const adminStats = [
  { label: "Active workspaces", value: 142, sub: "+6 this month" },
  { label: "Total users", value: 618, sub: "+24 this month" },
  { label: "Principals managed", value: 197, sub: "across all accounts" },
  { label: "Trials in progress", value: 11, sub: "3 ending this week" },
];

export const workspaceUsers = [
  { id: "u_001", name: "Amelia Hart", email: "amelia.hart@vancehousehold.com", role: "Executive Assistant", access: "Owner", status: "active", lastActive: "Active now" },
  { id: "u_002", name: "James Whitfield", email: "james.w@vancehousehold.com", role: "Personal Assistant", access: "Editor", status: "active", lastActive: "2 hours ago" },
  { id: "u_003", name: "Priya Nair", email: "priya.n@vancehousehold.com", role: "Household Manager", access: "Editor", status: "active", lastActive: "Yesterday" },
  { id: "u_004", name: "Jonathan Vance", email: "j.vance@vancecapital.com", role: "Principal (viewer)", access: "Read-only", status: "invited", lastActive: "Never" },
];

export const statusMeta = {
  // tasks
  "todo": { label: "To do", cls: "bg-info-foreground text-info" },
  "in-progress": { label: "In progress", cls: "bg-warning-foreground text-warning" },
  "done": { label: "Done", cls: "bg-success-foreground text-success" },
  "overdue": { label: "Overdue", cls: "bg-danger-foreground text-danger" },
  // docs / renewals
  "valid": { label: "Valid", cls: "bg-success-foreground text-success" },
  "expiring": { label: "Expiring", cls: "bg-warning-foreground text-warning" },
  "due-soon": { label: "Due soon", cls: "bg-warning-foreground text-warning" },
  "scheduled": { label: "Scheduled", cls: "bg-info-foreground text-info" },
  // workspace
  "active": { label: "Active", cls: "bg-success-foreground text-success" },
  "trial": { label: "Trial", cls: "bg-neutral-100 text-neutral-600" },
  "suspended": { label: "Suspended", cls: "bg-danger-foreground text-danger" },
  "invited": { label: "Invited", cls: "bg-neutral-100 text-neutral-600" },
  // severity
  "critical": { label: "Critical", cls: "bg-danger-foreground text-danger" },
  "warning": { label: "Warning", cls: "bg-warning-foreground text-warning" },
  "info": { label: "Info", cls: "bg-info-foreground text-info" },
  // priority
  "high": { label: "High", cls: "bg-danger-foreground text-danger" },
  "medium": { label: "Medium", cls: "bg-warning-foreground text-warning" },
  "low": { label: "Low", cls: "bg-neutral-100 text-neutral-600" },
  // expenses
  "pending": { label: "Pending", cls: "bg-warning-foreground text-warning" },
  "approved": { label: "Approved", cls: "bg-info-foreground text-info" },
  "reimbursed": { label: "Reimbursed", cls: "bg-success-foreground text-success" },
  "paid": { label: "Paid", cls: "bg-info-foreground text-info" },
  // trips
  "confirmed": { label: "Confirmed", cls: "bg-success-foreground text-success" },
  "planning": { label: "Planning", cls: "bg-info-foreground text-info" },
  "completed": { label: "Completed", cls: "bg-neutral-100 text-neutral-600" },
};

// ----- Travel / itineraries -----
export const trips = [
  {
    id: "trip_001", destination: "Geneva, Switzerland", purpose: "Vance Capital board meeting",
    startDate: "2026-07-04", endDate: "2026-07-06", travelers: "Jonathan Vance", status: "confirmed",
    flights: [
      { id: "f1", label: "LCY → GVA", detail: "BA 8722 · 09:40 · Terminal City Airport" },
      { id: "f2", label: "GVA → LCY", detail: "BA 8735 · 18:20" },
    ],
    hotel: "Hotel Beau-Rivage, Geneva — 2 nights",
    transfer: "Private car — David Okoye on arrival",
    notes: "Board papers packed. Lounge access confirmed. Travel insurance active.",
  },
  {
    id: "trip_002", destination: "Cornwall, United Kingdom", purpose: "Family half-term break",
    startDate: "2026-08-12", endDate: "2026-08-18", travelers: "Vance family (5)", status: "planning",
    flights: [],
    hotel: "The Nare Hotel, Carne Beach",
    transfer: "Family SUV — self drive",
    notes: "Book two family rooms plus a cot for Lily. Confirm dog-friendly.",
  },
];

// ----- Expenses -----
export const expenses = [
  { id: "exp_001", date: "2026-06-27", merchant: "British Airways", category: "Travel", amount: 1240.00, currency: "£", status: "reimbursed", person: "Jonathan", notes: "Geneva return flights", receipt: "" },
  { id: "exp_002", date: "2026-06-28", merchant: "Hotel Beau-Rivage", category: "Accommodation", amount: 820.50, currency: "£", status: "pending", person: "Jonathan", notes: "2 nights deposit", receipt: "" },
  { id: "exp_003", date: "2026-06-25", merchant: "Hillcrest Prep", category: "Education", amount: 18600.00, currency: "£", status: "approved", person: "Sophie & Oliver", notes: "Autumn term fees", receipt: "" },
  { id: "exp_004", date: "2026-06-24", merchant: "Waitrose", category: "Household", amount: 342.18, currency: "£", status: "reimbursed", person: "Household", notes: "Weekly groceries", receipt: "" },
  { id: "exp_005", date: "2026-06-29", merchant: "Apex Private Insurance", category: "Insurance", amount: 2340.00, currency: "£", status: "pending", person: "Household", notes: "Motor policy renewal", receipt: "" },
];

// ----- Budgets (event / project budgeting) -----
export const budgets = [
  {
    id: "b_001", name: "Eleanor's 50th Birthday", occasion: "Birthday celebration", currency: "£", createdAt: "2026-06-20",
    items: [
      { id: "bi_1", category: "Venue", vendor: "Regent Garden", budget: 50000, actual: 50000, status: "approved", paymentDate: "2026-08-12" },
      { id: "bi_2", category: "F&B", vendor: "Sexy Fish (booth)", budget: 5000, actual: 4800, status: "approved", paymentDate: "2026-08-10" },
      { id: "bi_3", category: "F&B", vendor: "Krispy Kreme", budget: 1000, actual: 0, status: "pending", paymentDate: "" },
      { id: "bi_4", category: "Gifts", vendor: "Cartier", budget: 8000, actual: 0, status: "pending", paymentDate: "" },
      { id: "bi_5", category: "Transport", vendor: "Private hire", budget: 1200, actual: 1200, status: "paid", paymentDate: "2026-08-12" },
    ],
  },
  {
    id: "b_002", name: "Kensington Home Renovation", occasion: "Home renovation", currency: "£", createdAt: "2026-05-01",
    items: [
      { id: "bi_6", category: "Design", vendor: "Studio Ashby", budget: 15000, actual: 15000, status: "paid", paymentDate: "2026-05-15" },
      { id: "bi_7", category: "Build", vendor: "Beaufort Builders", budget: 120000, actual: 60000, status: "approved", paymentDate: "2026-06-01" },
      { id: "bi_8", category: "Furnishing", vendor: "The Conran Shop", budget: 25000, actual: 0, status: "pending", paymentDate: "" },
    ],
  },
];

export const getPerson = (id) => people.find((p) => p.id === id);
